
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import  { apibaseURl , loggedInCustomerDetails ,  errorToast , successToast , warningToast }  from "../../functions/Function";

const SearchItem = (props) => {
    const [starfill, setStarfill] = useState(props.fill);
    const addTofav = async (product_id) => {
        setStarfill(true)
        try {
            let res = await fetch(apibaseURl + "addfavoriteitem", {
              method: "POST",
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                user_id: loggedInCustomerDetails('id'),
                product_id:product_id
            }),
            });
            let output = await res.json();
            if (res.status === 200) {
                if (output.result === true) {
                    successToast('Product added in favorite list' , 'bottom-right' , 1500  , true);
              }
      
            }
          } catch (err) {
           
          }
        }

        const alreadyAdded = () => 
        {
            warningToast('Product already added.' , 'bottom-right' , 1500  , true);
        }
    return (
        <>  
            <li  onClick={ starfill == false ?   () => addTofav(props.row.id) : () => alreadyAdded()  } className="ivo-left-index-li ivo-ovrflow-hidden">
                <Link>
                    <div className="ivo-left-ul-inner-conent">
                        {props.row.name}
                    </div>
                    <div className="ivo-left-ul-inner-conent-v-2 hover-price-list">
                              
                        <span className="add-list-star"> 
                            {starfill == false ? <i className="fa-regular fa-star"></i> : <i className="fa-solid fa-star"></i>  }
                        </span>
                    </div>
                </Link>
            </li>
        </>

    );
}

export default SearchItem;
